import React, { useState, useEffect } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import AlertMessage from 'Components/Alert';
import Modal from 'Components/Modal';
import Options from 'Components/Options';
import ModalInformation from '../../Components/ModalInformation';
import useModal from '../../Hooks/useModal';
import useLesson from '../../Hooks/useLesson';
import useEvaluation from '../../Hooks/useEvaluation';
import Title from '../../Components/Title';
import Tabs from './Components/tabs';
import useQuestions from './Hooks/useQuestions';
import useValidation from './Hooks/useValidation';

function LessonAuto({
  addLessonSession,
  addLessonAutoEvaluation,
  module,
  updateLesson,
  currentPositionLesson,
  deleteLesson,
  updateLessonSessionData,
  alert,
  setAlert,
}) {
  const lesson = module?.lessons?.[currentPositionLesson];
  const [formData, setFormData] = useState({
    evaluationName: lesson?.name || '',
    duration: lesson?.duration || null,
    isRandomQuestionOrder: lesson?.isRandomQuestionOrder || false,
    preventTabSwitching: lesson?.preventTabSwitching || false,
    errors: [],
  });
  const [unchanged, setUnchanged] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const { t2 } = useTranslation('EditCourse');
  const { openModal, setOpenModal } = useModal();

  useEffect(() => {
    if (alert) {
      setAlertMessage(t2(`${alert}`));
      setAlertOpen(true);
      setTimeout(() => {
        setAlert('');
      }, 2000);
    }
  }, [alert]);

  const { isDraft, setIsDraft, onDelete } = useLesson({
    module,
    updateLesson,
    lesson,
    deleteLesson,
  });

  const { onCreateAutoEvaluation, onUpdateAutoEvaluation } = useEvaluation({
    addLessonSession,
    addLessonAutoEvaluation,
    module,
    updateLesson,
    updateLessonSessionData,
    isDraft,
  });

  const { questions } = useQuestions({ lessonId: lesson?.id });

  const enableButton = () => {
    if (lesson?.id) return t2('SaveChanges');

    return t2('Save');
  };

  const handleModalAccept = async () => {
    setOpenModal(false);

    if (lesson?.id) {
      await onUpdateAutoEvaluation({ ...formData, id: lesson.id });

      return;
    }

    onCreateAutoEvaluation(formData);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const { validate } = useValidation({ formData, setFormData, t2 });

  const checkValidation = () => {
    const isValid = validate();
    if (isValid) {
      setOpenModal(true);
    }
  };

  useEffect(() => {
    if (questions) {
      setFormData({ ...formData, questions });
    }
  }, [questions, lesson]);

  return (
    <div>
      <Title
        name={t2('Evaluacion Automatica')}
        textButton={enableButton()}
        check={isDraft}
        setCheck={setIsDraft}
        setUnchanged={setUnchanged}
        checkText={t2('Draft')}
        checkInfo={t2('DraftCondition')}
        checkDisabled={false}
        setOpenModal={checkValidation}
        buttonDisabled={unchanged}
      >
        <Options Icon={<MoreVert />} disabledEffect>
          <MenuItem onClick={onDelete}>{t2('DeleteLesson')}</MenuItem>
        </Options>
      </Title>
      <Tabs formData={formData} setFormData={setFormData} setUnchanged={setUnchanged} lessonId={lesson?.id} />
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <ModalInformation accept={handleModalAccept} cancel={handleModalClose} title={t2('ModalTitleEvaluation')} />
        }
      />
      <AlertMessage message={alertMessage} open={alertOpen} setOpen={setAlertOpen} />
    </div>
  );
}

export default LessonAuto;
